import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

const REVIEW_URL = 'https://apps.shopify.com/invoice-browse?#modal-show=ReviewListingModal';

class ReviewPrompt extends Component {
    constructor(props) {
        super(props);
        this.state = { visible: true };
    }

    dismiss(resetCounter) {
        this.setState({ visible: false });
        if (this.props.onDismiss) this.props.onDismiss(resetCounter);
    }

    render() {
        if (!this.state.visible) return null;
        const { intl } = this.props;

        return (
            <div style={{position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.5)', zIndex:999999, display:'flex', alignItems:'center', justifyContent:'center'}}>
                <div style={{background:'#fff', borderRadius:'12px', padding:'32px', maxWidth:'420px', width:'90%', textAlign:'center', boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>
                    <div style={{fontSize:'36px', marginBottom:'12px'}}>⭐⭐⭐⭐⭐</div>
                    <h3 style={{margin:'0 0 8px', fontSize:'20px', color:'#1e293b'}}><FormattedMessage id="review.enjoying" /></h3>
                    <p style={{color:'#64748b', fontSize:'14px', margin:'0 0 20px', lineHeight:'1.5'}}>
                        <FormattedMessage id="review.description" />
                    </p>
                    <p style={{background:'#f0fdfa', border:'1px solid #99f6e4', borderRadius:'6px', padding:'10px 14px', color:'#0f766e', fontSize:'13px', fontWeight:'600', margin:'0 0 20px'}}>
                        <FormattedMessage id="review.reward" />
                    </p>
                    <div style={{display:'flex', flexDirection:'column', gap:'10px'}}>
                        <a href={REVIEW_URL} target="_blank" rel="noopener noreferrer"
                            onClick={() => this.dismiss(true)}
                            style={{display:'inline-block', padding:'12px 24px', background:'#0d9488', color:'#fff', borderRadius:'8px', fontWeight:'600', fontSize:'14px', textDecoration:'none', cursor:'pointer'}}>
                            <FormattedMessage id="review.leaveReview" /> ★
                        </a>
                        <button onClick={() => this.dismiss(false)}
                            style={{padding:'10px 24px', background:'none', border:'none', color:'#94a3b8', fontSize:'13px', cursor:'pointer'}}>
                            <FormattedMessage id="review.maybeLater" />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(ReviewPrompt);



// WEBPACK FOOTER //
// app/components/ReviewPrompt.jsx